/**
 * 市场项目地图视图上下文
 */

import type { MarketProject } from '../../../types/market';
import { projectsInProvince } from '../../../utils/marketHelpers';
import { provinceAdcodeToGeoName } from '../provinceAdcode';
import { distanceFromProvinceSpan } from './geoHelpers';
import type { DrillState, MapLayoutMode, MapViewContext } from '../types';
import { chinaOverviewContext } from './viewContext';

export function buildMarketViewContext(
  projects: MarketProject[],
  drill: DrillState,
  focusAdcode: string | null,
  layoutMode: MapLayoutMode,
  drillTargetCoord: [number, number] | null = null,
): MapViewContext {
  if (focusAdcode == null) {
    return {
      ...chinaOverviewContext([]),
      scatterParks: [],
      scatterMarketProjects: projects,
    };
  }

  const highlightName = provinceAdcodeToGeoName(focusAdcode);
  const inProvince = projectsInProvince(projects, focusAdcode);

  if (layoutMode === 'nationalOverview') {
    return {
      ...chinaOverviewContext([], {
        highlightProvinceGeoName: highlightName,
      }),
      scatterParks: [],
      scatterMarketProjects: inProvince,
    };
  }

  if (drill.kind === 'ready' && drill.adcode === focusAdcode) {
    const geoAspectRatio =
      drill.lngSpan && drill.latSpan ? drill.lngSpan / drill.latSpan : null;
    const centerLng = drillTargetCoord ? drillTargetCoord[0] : drill.centroid[0];
    const centerLat = drillTargetCoord ? drillTargetCoord[1] : drill.centroid[1];

    return {
      mapName: drill.mapName,
      targetLngLat: [centerLng, centerLat, 0],
      viewDistance: distanceFromProvinceSpan(drill.spanDeg),
      viewAlpha: 89,
      viewBeta: 0,
      scatterParks: [],
      scatterMarketProjects: inProvince,
      drillLoading: false,
      highlightProvinceGeoName: highlightName,
      highlightCityGeoName: null,
      geoAspectRatio,
    };
  }

  return {
    ...chinaOverviewContext([], {
      drillLoading: true,
      highlightProvinceGeoName: highlightName,
    }),
    scatterParks: [],
    scatterMarketProjects: inProvince,
  };
}
